import instance from "@/utils/require.js"
import store from "@/store/store.js"

// 上传文件
export function apiUploadFile(data = {}) {
	return instance({
		url: "/aim/api/v3/archive/upload",
		method: "post",
		data
	})
}

// 上传文件夹
export function apiUploadDolder(data = {}) {
	return instance({
		url: "/aim/api/v3/archive/upload/folder",
		method: "post",
		data
	})
}

// 联想ODM报告分页查询
export function apiLenovoPsdSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo/odm/sync/search",
		method: "post",
		data
	})
}

// 联想ODM报告上传PSD
export function apiLenovoPsdUploadPsd(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo/odm/sync/upload/psd",
		method: "post",
		data
	})
}

// 联想ODM报告上传PBS
export function apiLenovoPsdUploadPbs(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo/odm/sync/upload/bps",
		method: "post",
		data
	})
}

// 联想ODM--手动同步BOM
export function apiLenovoOdmSyncBom(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo/odm/sync/send/bom",
		method: "post",
		data
	})
}

// 联想ODM--手动同步Inventory
export function apiLenovoOdmSyncInventory(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo/odm/sync/send/inventory",
		method: "post",
		data
	})
}

// 联想ODM--手动同步Location Mapping
export function apiLenovoOdmSyncLocation(data = {}) {
	return instance({
		url: "/aim/api/v3/lenovo/odm/sync/send/location",
		method: "post",
		data
	})
}

// 下载文件
export function apiDownloadFile(fid, secret) {
	if (secret) {
		return `${store.state.baseURL}/aim/api/v3/archive/download/${fid}?secret=${secret}`;
	} else {
		return `${store.state.baseURL}/aim/api/v3/archive/download/${fid}`
	}
}